import { render } from "./ColsDropdown.vue?vue&type=template&id=0ecd0c0b&ts=true"
import script from "./ColsDropdown.vue?vue&type=script&lang=ts"
export * from "./ColsDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__